import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { articleNumber } from '../Actions/Product.action';

export default function SizeSelector() {
    const dispatch = useDispatch();
    const product = useSelector((state) => state.product);
    const setArticleNumber = (number) => {
        console.log(number);
        dispatch(articleNumber(number));
    };
    return (
        <ul className="product-detail__variant-size" data-filter="sizefilter" id="sizefilter">
            {product.sizes.map((item) => {
                return (
                    <li className="product-detail__selector-item" key={item.articleNumber}>
                        <button
                            className={`product-detail__selector-size ${product.currentArticleNumber === item.articleNumber ? 'is-active' : ''}`}
                            type="button"
                            data-article-number={item.articleNumber}
                            data-size={item.size}
                            disabled={item.disabled}
                            onClick={() => setArticleNumber(item.articleNumber)}
                        >
                            {item.name}
                        </button>
                    </li>
                );
            })}
        </ul>
    );
}
